import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useCart } from "../../lib/cart-context";
import { formatBRL } from "../../lib/currency";
import { apiClient, ApiError } from "../../lib/api-client";

export function CartPage() {
  const { cartId, items, loading } = useCart();
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const subtotal = items.reduce((sum, item) => sum + item.unit_price_cents * item.quantity, 0);

  async function handleCheckout() {
    if (!cartId) return;
    setSubmitting(true);
    setError(null);
    try {
      const result = await apiClient.post<{ orderId: string }>("/consumer/checkout/pix", { cartId });
      navigate(`/checkout/${result.orderId}`);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Não foi possível iniciar o checkout.");
    } finally {
      setSubmitting(false);
    }
  }

  if (loading) return <p className="text-muted">Carregando…</p>;

  return (
    <div>
      <h1>Carrinho</h1>
      {items.length === 0 ? (
        <p className="empty-state">Seu carrinho está vazio.</p>
      ) : (
        <div className="card" style={{ maxWidth: 640 }}>
          <table className="data-table">
            <thead>
              <tr>
                <th>Livro</th>
                <th>Qtd.</th>
                <th>Preço</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item) => (
                <tr key={item.id}>
                  <td>{item.title}</td>
                  <td className="num">{item.quantity}</td>
                  <td className="num">{formatBRL(item.unit_price_cents * item.quantity)}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="summary-row">
            <span>Subtotal</span>
            <span>{formatBRL(subtotal)}</span>
          </div>

          {error && (
            <div
              role="alert"
              style={{
                marginTop: "var(--space-4)",
                padding: "var(--space-3) var(--space-4)",
                background: "rgba(192, 57, 43, 0.08)",
                border: "1px solid var(--color-brass-line)",
                borderRadius: "var(--radius-sm)",
              }}
            >
              <p style={{ margin: 0, fontWeight: 500 }}>{error}</p>
              {error.toLowerCase().includes("login") && (
                <div style={{ marginTop: "var(--space-3)" }}>
                  <a href="/login?redirect=/carrinho" className="btn btn-secondary" style={{ fontSize: "var(--text-xs)", display: "inline-block" }}>
                    Fazer Login para continuar a compra
                  </a>
                </div>
              )}
            </div>
          )}

          <button className="btn" disabled={submitting} onClick={handleCheckout} style={{ marginTop: "var(--space-5)", width: "100%" }}>
            {submitting ? "Gerando Pix…" : "Finalizar compra com Pix"}
          </button>
        </div>
      )}
    </div>
  );
}
